import { createFileRoute } from '@tanstack/react-router'
import { ComparisonPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/it/confronta/$comparisonSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'comparison', locale: 'it', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { comparisonSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ComparisonPage comparisonSlug={comparisonSlug} />
    </CatalogProvider>
  )
}
